import React from 'react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Textarea } from './ui/textarea';
import { Label } from './ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from './ui/select';
import { Send } from 'lucide-react';

export const ContactForm = ({ t, formData, isSubmitting, handleChange, handleSubmit }) => {
  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      {/* Name Field */}
      <div className="space-y-2">
        <Label htmlFor="name" className="text-[#001f3f] font-semibold">
          {t.contact.form.name}
        </Label>
        <Input
          id="name"
          required
          value={formData.name}
          onChange={(e) => handleChange('name', e.target.value)}
          className="border-slate-300 focus:border-[#D4AF37] focus:ring-[#D4AF37] transition-colors"
          placeholder={t.language === 'fr' ? 'Jean Dupont' : 'John Smith'}
        />
      </div>

      {/* Email Field */}
      <div className="space-y-2">
        <Label htmlFor="email" className="text-[#001f3f] font-semibold">
          {t.contact.form.email}
        </Label>
        <Input
          id="email"
          type="email"
          required
          value={formData.email}
          onChange={(e) => handleChange('email', e.target.value)}
          className="border-slate-300 focus:border-[#D4AF37] focus:ring-[#D4AF37] transition-colors"
          placeholder="jean.dupont@email.com"
        />
      </div>

      {/* Phone Field */}
      <div className="space-y-2">
        <Label htmlFor="phone" className="text-[#001f3f] font-semibold">
          {t.contact.form.phone}
        </Label>
        <Input
          id="phone"
          type="tel"
          value={formData.phone}
          onChange={(e) => handleChange('phone', e.target.value)}
          className="border-slate-300 focus:border-[#D4AF37] focus:ring-[#D4AF37] transition-colors"
          placeholder="+33 6 12 34 56 78"
        />
      </div>

      {/* Type Field */}
      <div className="space-y-2">
        <Label htmlFor="type" className="text-[#001f3f] font-semibold">
          {t.contact.form.type}
        </Label>
        <Select 
          value={formData.type} 
          onValueChange={(value) => handleChange('type', value)}
          required
        >
          <SelectTrigger className="border-slate-300 focus:border-[#D4AF37] focus:ring-[#D4AF37]">
            <SelectValue placeholder={t.language === 'fr' ? 'Sélectionnez...' : 'Select...'} />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="professional">{t.contact.form.typeProfessional}</SelectItem>
            <SelectItem value="individual">{t.contact.form.typeIndividual}</SelectItem>
          </SelectContent>
        </Select>
      </div>

      {/* Message Field */}
      <div className="space-y-2">
        <Label htmlFor="message" className="text-[#001f3f] font-semibold">
          {t.contact.form.message}
        </Label>
        <Textarea
          id="message"
          required
          value={formData.message}
          onChange={(e) => handleChange('message', e.target.value)}
          className="border-slate-300 focus:border-[#D4AF37] focus:ring-[#D4AF37] min-h-[150px] transition-colors resize-none"
          placeholder={t.language === 'fr' ? 'Décrivez votre besoin...' : 'Describe your need...'}
        />
      </div>

      {/* Submit Button */}
      <Button
        type="submit"
        disabled={isSubmitting}
        className="w-full bg-gradient-to-r from-[#D4AF37] to-[#FFD700] text-[#001f3f] hover:shadow-2xl hover:shadow-[#D4AF37]/50 transition-all duration-300 font-semibold py-6 text-lg hover:scale-105"
      >
        {isSubmitting ? (
          <span className="flex items-center justify-center gap-2">
            <div className="w-5 h-5 border-2 border-[#001f3f]/30 border-t-[#001f3f] rounded-full animate-spin"></div>
            {t.contact.form.submitting}
          </span>
        ) : (
          <span className="flex items-center justify-center gap-2">
            <Send className="w-5 h-5" />
            {t.contact.form.submit}
          </span>
        )}
      </Button>
    </form>
  );
};
